import React, { ReactElement, ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { InitialLoader } from '../InitialLoader';
import { TopNotificationBasicRenderProp } from '../TableTopNotification';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { QueryResultStatusError, TaskState } from '@wix/bex-core';
import { TableSkeleton } from '../TableSkeleton/TableSkeleton';
import { PlaceholderStatesBase } from '../PlaceholderStates/PlaceholderStatesBase';
import { TableProps } from '@wix/design-system';

export interface TablePlaceholderStatesProps {
  state: {
    initTask: TaskState<unknown>;
    showLoadingState: boolean;
    showEmptyState: boolean;
    showErrorState: boolean;
    errorStatus: QueryResultStatusError<unknown, unknown> | null | undefined;
    retryErrorState: () => void;
  };
  renderError?: (params: {
    err: unknown;
    isOnline: boolean;
    retry: () => void;
  }) => ReactElement;
  renderEmptyState?: () => ReactElement;
  topNotification?: TopNotificationBasicRenderProp;
  children?: ReactNode;
  rowVerticalPadding?: TableProps['rowVerticalPadding'];
}

function _TablePlaceholderStates(props: TablePlaceholderStatesProps) {
  const state = useToolbarCollectionContext();

  const tableSkeletonEnabled = state.container.internalExperiments?.enabled(
    'specs.cairo.TableSkeletonLoader',
  );

  return (
    <PlaceholderStatesBase
      loadingState={
        tableSkeletonEnabled ? (
          <TableSkeleton
            dataHook="placeholder-states-loading-state"
            rowVerticalPadding={props.rowVerticalPadding}
          />
        ) : (
          <InitialLoader
            dataHook="placeholder-states-loading-state"
            state={state}
          />
        )
      }
      {...props}
    />
  );
}

export const TablePlaceholderStates = observer(_TablePlaceholderStates);
